<template>
  <div v-if="displayGaleryPreview">
    <div class="row">
      <div class="col-12 d-flex mb-2">
        <div class="small fw-bold">
          {{ 'Photos' | translate }}
        </div>
        <div class="ms-auto">
          <a class="small" :href="`/community/gallery${urlSuffix}`">
            {{ 'See all' | translate }}
          </a>
        </div>
      </div>

      <div class="col-4 mb-3" v-for="post in community_posts" :key="post.id">
        <div class="ratio ratio-1x1">
          <div class="overflow-hidden rounded">
            <a :href="postLink(post)">
              <img
                style="width: 100%; height: 100%; object-fit: cover"
                :src="`https://djceg34j53tq.cloudfront.net/${post.image}`"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: ['topicId'],
  data: () => ({
    community_posts: [],
  }),
  mounted() {
    axios
      .post(`/json/community/gallery-preview${this.urlSuffix}`)
      .then(({ data }) => {
        this.community_posts = data.community_posts
      })
  },
  methods: {
    postLink(post) {
      return `${window.location.protocol}//${window.location.host}/community/posts/${post.id}`
    },
  },
  computed: {
    urlSuffix() {
      if (this.topicId) {
        return `/${this.topicId}`
      }
      return ''
    },
    displayGaleryPreview() {
      return this.community_posts.length >= 1
    },
    displayShowMoreButton() {
      return this.community_posts.length >= 6
    },
  },
}
</script>

<style></style>
